
import React, { useState, useEffect, useRef } from 'react'
import { useInView } from 'react-intersection-observer';
import { Link } from "react-router-dom";

const Banner = (props) => {
  const { ref, inView } = useInView({
    threshold: 0.5, // 영역의 50% 이상이 보일 때 활성화
  });
  const scrollRef = useRef(0);
  const [isActive, setIsActive] = useState(false); // isActive 상태 추가

  useEffect(() => {
    // inView 값이 변경될 때마다 isActive 상태 업데이트
    setIsActive(inView);
  }, [inView]);


  const handleLinkClick = () => {
    scrollRef.current = window.pageYOffset;
    window.scrollTo(0, scrollRef.current);
    setTimeout(function(){
        window.scrollTo(0, 0);
    },600)
  };
  
  return (
    <section className={`${props.classType} ${isActive ? 'active' : ''}`} ref={ref}>
      <div className="banner-bg"></div>
      <div className="banner-content">

        <div className="banner-title">
          <div className="title-union"><img src={props.unionSrc} alt="" /></div>
          <h2>
            <picture>
              <source media="(min-width: 1024px)" srcSet={props.titleSrcPc} />
              <source media="(min-width: 768px) and (max-width: 1023px)" srcSet={props.titleSrcTab} />
              <source media="(min-width: 0px) and (max-width: 767px)" srcSet={props.titleSrcMo} />
              <img src={props.titleSrcPc} alt={props.title} />
            </picture>
          </h2>
        </div>
        <div className="banner-desc">
          <p>{props.description1}</p>
          <p>{props.description2}</p>
        </div>
        <div className="banner-link">
          <Link to={props.link} onClick={handleLinkClick}><span>{props.linkDesc}</span></Link>
        </div>
      </div>
    </section>
  )
}

export default Banner